import { useCoreSelector } from '../../CoreStore';

export const useMiniLobbySlice = {
  getIsIframeLoaded: (): boolean => {
    return useCoreSelector(({ minilobby }) => minilobby.isIframeLoaded);
  },
  getIsLobbyFullscreen: (): boolean => {
    return useCoreSelector(({ minilobby }) => minilobby.isLobbyFullscreen);
  },
  getIsSlotsLobbyLoading: (): boolean => {
    return useCoreSelector(({ minilobby }) => minilobby.isSlotsLobbyLoading);
  },
  getIsSlotsLobbyHasError: (): boolean => {
    return useCoreSelector(({ minilobby }) => minilobby.isSlotsLobbyHasError);
  },
  getSlotsLobbyErrorCount: (): number => {
    return useCoreSelector(({ minilobby }) => minilobby.slotsLobbyErrorCount);
  },
};
